<template>
  <div class="root">
    <GameBackground />
    <Header
      :amountOfQuestions="questions.length"
      :totalCoins="coins"
      :showCoins="
        waitingAnswer || question.correctIndex.includes(userSelectionIndex)
      "
      :answers="answersArray"
      class="header"
      ref="header"
    >
      <template v-slot:countdown>
        <Countdown
          v-show="waitingAnswer"
          :timeLeft="timeLeft"
          :initialTime="initialTime"
          :onHud="true"
        />
      </template>
    </Header>

    <div ref="card" class="card">
      <div>
        <div v-if="waitingAnswer" class="hud">
          <span class="questionNumber">
            {{ questionLabel }}
          </span>
          <div>
            <img
              src="@/assets/images/flourish-coin-darker.svg"
              class="flourish-coins-image"
              width="32px"
              height="32px"
              alt=""
            />
            <span class="flourish-coins">{{ currentCoins }}</span>
          </div>
        </div>
        <div v-else>
          <span
            :class="{
              questionResult: true,
              positive: isCorrect,
              negative: isWrong,
            }"
          >
            {{ question.status }}
          </span>
        </div>
      </div>

      <div class="questionOrFeedback">
        <span v-if="waitingAnswer">
          {{ question.question }}
        </span>
        <span
          v-else
          :class="{
            questionFeedback: true,
            positive: isCorrect,
            negative: isWrong,
          }"
        >
          {{ question.feedback }}
        </span>
      </div>
      <transition-group name="slide-fade" tag="div">
        <div v-for="(option, i) in question.options" :key="i" ref="option">
          <button
            @click="selectAnswer(i)"
            :class="getOptionClass(i)"
            :disabled="!waitingAnswer"
            :tabindex="i"
          >
            {{ option }}
          </button>
        </div>
      </transition-group>
    </div>
    <footer ref="footer">
      <button
        v-if="waitingAnswer"
        :class="{
          confirm: waitingAnswer || userSelectionIndex < 0,
          disabled: !waitingAnswer || userSelectionIndex < 0,
        }"
        @click="checkAnswer"
        :disabled="!waitingAnswer || userSelectionIndex < 0"
      >
        Confirm
      </button>
      <div v-else>
        <div class="tip-session">
          <span
            :class="{
              questionFeedback: true,
              positive: isCorrect,
              negative: isWrong,
            }"
            >{{ question.userFeedback }}</span
          >
          <!-- <a
            v-if="shouldAskForEmail"
            @click="openEmailModal()"
            :class="{
              questionFeedback: true,
              positive: isCorrect,
              negative: isWrong,
            }"
            >Do you want to know more?</a
          > -->
        </div>
        <button color="secondary" class="confirm" @click="loadQuestion">
          Next
        </button>
      </div>
    </footer>
    <!--<DoOver v-if="showModal" @closeModal="onCloseModal" />-->
    <!-- <Modal v-if="showEmailModal" @closeModal="onCloseEmailModal" /> -->
  </div>
</template>

<script>
let clock = undefined;
import { extraQuestion } from "../utils/questions.json";
import { questionsResult /* doOverActions */ } from "@/utils/enums";
import Header from "../components/Header.vue";
import GameBackground from "../components/GameBackground.vue";
//import DoOver from "../components/DoOver.vue";
import Countdown from "../components/Countdown.vue";
//import Modal from "../components/Modal.vue";
import { routesName } from "@/router";
import { mapActions } from "vuex";

export default {
  components: {
    Countdown,
    Header,
    GameBackground,
    //DoOver,
    //Modal,
  },
  data: () => ({
    //: false,
    //showModal: false,
    //showEmailModal: false,
    //shouldAskForEmail: true,
    timeLeft: 0,
    initialTime: 0,
    waitingAnswer: true,
    currentIndex: -1,
    userSelectionIndex: -1,
    //doOvers: 0,
    skip: false,
    question: {
      number: Number,
      status: String,
      question: String,
      feedback: String,
      options: [],
      timerToAnswer: Number,
      correctIndex: Number,
    },
    extraQuestion: extraQuestion,
    answersArray: [],
  }),
  computed: {
    questions() {
      return this.$store.state.questions;
    },
    coins() {
      return this.$store.state.coinsBalance;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    // shouldAskForDoOVer() {
    //   return (
    //     this.doOvers > 0 &&
    //     (this.question.userFeedback == questionsResult.WRONG ||
    //       this.question.userFeedback == questionsResult.TIMEOUT) &&
    //     !this.skip
    //   );
    // },
    isCorrect() {
      return this.question.userFeedback == questionsResult.CORRECT;
    },
    isWrong() {
      return (
        this.question.userFeedback == questionsResult.WRONG ||
        this.question.userFeedback == questionsResult.TIMEOUT
      );
    },
    questionLabel() {
      return `Question ${this.currentIndex + 1}`;
    },
    currentCoins() {
      return `+${this.question.coins}`;
    },
    rightAnswers() {
      return this.answersArray.filter((el) => el == questionsResult.CORRECT)
        .length;
    },
    numOfQuestions() {
      return this.triviaQuestions.length;
    },
  },
  methods: {
    ...mapActions(["recordEndDate", "sendScore"]),
    createAnswersArray() {
      this.answersArray = [...this.questions].map(() => null);
    },
    // openEmailModal() {
    //   this.showEmailModal = true;
    //   let eventName =
    //     process.env.VUE_APP_ANALYTICS_EVENT_BASE + "WantToKnowMore";
    //   this.$logEvent(eventName, {
    //     question: this.question.content,
    //   });
    // },
    // onCloseEmailModal(args) {
    //   console.log(args);
    //   this.showEmailModal = false;
    //   if (args) {
    //     let eventName = process.env.VUE_APP_ANALYTICS_EVENT_BASE + "UserEmail";
    //     this.$logEvent(eventName, {
    //       email: args,
    //       question: this.question.content,
    //     });
    //     this.shouldAskForEmail = false;
    //   }
    // },
    // onCloseModal(args) {
    //   this.showModal = false;
    //   switch (args) {
    //     case doOverActions.SKIP:
    //       this.skipDoOver();
    //       break;
    //     case doOverActions.USE:
    //       this.doOver();
    //       break;
    //   }
    // },
    // skipDoOver() {
    //   this.skip = true;
    //   this.loadQuestion();
    // },
    // doOver() {
    //   this.doOvers -= 1;
    //   this.isDoOver = true;
    //   this.question = this.extraQuestion;
    //   this.userSelectionIndex = -1;
    //   this.initTimer();
    //   this.scrollTo(this.$refs.header);
    // },
    getOptionClass(index) {
      let result = {};
      if (!this.waitingAnswer) {
        if (
          this.question.correctIndex.includes(index) &&
          this.userSelectionIndex === index
        ) {
          result.correct = true;
        } else if (this.userSelectionIndex === index) {
          result.wrong = true;
        } else {
          result.unfocused = true;
        }
      } else {
        result.focus = index == this.userSelectionIndex;
      }
      return result;
    },
    showOption(index) {
      return (
        this.waitingAnswer ||
        (!this.waitingAnswer && index === this.userSelectionIndex) ||
        (!this.waitingAnswer && this.question.correctIndex.includes(index))
      );
    },
    initTimer() {
      this.waitingAnswer = true;
      if (this.question.timeToAnswer > 0) {
        this.timeLeft = this.question.timeToAnswer;
        this.initialTime = this.question.timeToAnswer;
        clock = setInterval(() => {
          this.timeLeft--;
          if (this.timeLeft < 0) {
            this.checkAnswer();
          }
        }, 1000);
      } else {
        this.timeLeft = Number.POSITIVE_INFINITY;
      }
    },
    loadQuestion() {
      // if (this.shouldAskForDoOVer) {
      //   this.showModal = true;
      //   return;
      // }
      this.skip = false;
      this.currentIndex++;
      this.userSelectionIndex = -1;
      if (this.questions.length > this.currentIndex) {
        this.question = this.questions[this.currentIndex];
        this.initTimer();
      } else {
        // this.$router.push({
        //   path: routesName.gameOver,
        //   query: {
        //     numOfQuestions: this.numOfQuestions,
        //     rightAnswers: this.rightAnswers,
        //     coins: this.coins,
        //   },
        // });
        this.recordEndDate();
        this.sendScore();

        this.$router.push({
          path: routesName.feedback,
        });
      }
      this.scrollTo(this.$refs.header);
    },
    selectAnswer(index) {
      if (this.waitingAnswer) {
        this.userSelectionIndex = index;
      }
      this.scrollTo(this.$refs.footer);
    },
    checkAnswer() {
      clearInterval(clock);
      let answerStatus = "";
      if (this.waitingAnswer) {
        if (this.question.correctIndex.includes(this.userSelectionIndex)) {
          this.question.status = "Well done!";
          this.question.userFeedback = questionsResult.CORRECT;
          answerStatus = "CORRECT";
          this.$store.dispatch("answerQuestion", {
            id: this.question.id,
            answerSelected: this.userSelectionIndex,
            answerStatus,
          });
          this.$store.dispatch("updateCoinsBalance", {
            coins: this.question.coins,
          });
        } else if (this.userSelectionIndex == -1) {
          this.question.status = "Time is up";
          this.question.userFeedback = questionsResult.TIMEOUT;
          answerStatus = "TIMEOUT";
          this.$store.dispatch("answerQuestion", {
            id: this.question.id,
            answerSelected: null,
            answerStatus,
          });
        } else {
          this.question.status = "Dang! Almost";
          this.question.userFeedback = questionsResult.WRONG;
          answerStatus = "WRONG";
          this.$store.dispatch("answerQuestion", {
            id: this.question.id,
            answerSelected: this.userSelectionIndex,
            answerStatus,
          });
        }
        this.$set(
          this.answersArray,
          this.currentIndex,
          this.question.userFeedback
        );
        this.waitingAnswer = false;
        // let amplitudeProp = Object.assign(this.question, this.amplitudeProp, {
        //   timeLeft: this.timeLeft,
        //   isDoOver: this.isDoOver,
        //   userIndexSelection: this.userSelectionIndex,
        // });
        let eventName =
          process.env.VUE_APP_ANALYTICS_EVENT_BASE + "AnswerToQuestion";
        this.$logEvent(eventName, {
          id: this.question.id,
          question: this.question.question,
          answerStatus,
          userFeedbackAnswer: this.question.userFeedback,
          options: this.question.options,
          userAnswerSelected: this.question.options[this.userSelectionIndex],
          correctAnswer: this.question.answer,
          timeSpentInSeconds: this.initialTime - this.timeLeft,
        });
        // this.isDoOver = false;
      }
      this.scrollTo(this.$refs.card);
    },
    scrollTo(target) {
      this.$scrollTo(target);
    },
  },
  mounted() {
    this.loadQuestion();
    this.createAnswersArray();
    this.$store.dispatch("recordDateStart");
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";
@import "../scss/common.scss";
@import "../scss/animations.scss";

@media only screen and (min-width: 600px) {
  .root {
    max-width: 375px;
  }
}

.root {
  min-width: 320px;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  overflow: auto;
}

.card {
  padding: 1rem;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  background: $quaternary-darker;
  border: 1px solid $quinternary-darker;
  border-radius: 12px;
  flex: 2 1 auto;
}

.flourish-coins {
  font-family: $secondary-font;
  background-color: $secondary-darker;
  border-radius: 12px;
  font-size: 1.4rem;
  color: $quaternary-lighter;
  padding: 0.05rem 2rem 0.05rem 0.6rem;
}

.flourish-coins-image {
  transform: translateX(230%) translateY(25%);
}

.hud {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.questionNumber {
  font-family: $secondary-font;
  color: $primary;
  font-size: 1.4rem;
}

.questionResult {
  font-family: $secondary-font;
}

.questionResult.positive {
  color: $secondary;
}

.questionResult.negative {
  color: $tertiary;
}

.questionOrFeedback {
  margin: 1.4rem 0 1rem 0;
}

.questionOrFeedback > span {
  font-family: $primary-font;
  color: $primary;
  font-size: 1.1rem;
}

.questionFeedback {
  font-family: $primary-font;
  cursor: pointer;
}

a.questionFeedback {
  font-size: 0.7rem;
  text-decoration: underline;
}

.questionFeedback.positive {
  color: $secondary;
}

.questionFeedback.negative {
  color: $tertiary;
}

a.questionFeedback.negative {
  color: $tertiary-lighter;
}

.tip-session {
  display: flex;
  justify-content: space-between;
  flex-flow: row;
  align-items: baseline;
}

footer {
  bottom: 0;
  position: relative;
  margin: 1.4rem 0;
  width: 100%;
  flex: 1;
}

.header {
  flex: 1;
}

.hidden {
  visibility: hidden;
}
</style>
